import { Container } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getClientNovelties } from '../../../../../redux/actions/novelties'
import { IRootState } from '../../../../../redux/types'
import Header from '../../../../shared/components/Header'
import useSkeleton from '../../../../shared/components/layouts/SkeletonLayout'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import SubHeader from '../../../../shared/styles/Subheader'
import NoveltyPanel from '../components/NoveltyPanel'

function NoveltyHome() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { novelties } = useSelector((state: IRootState) => state.novelty)
  const { globalFamilyId, globalBrandId, globalCountryId, globalLanguageId, globalTag, globalRoleId } = useSelector(
    (state: IRootState) => state.global
  )

  const { loading: loadingSkeleton, component: componentSkeleton } = useSkeleton()

  useEffect(() => {
    dispatch(
      getClientNovelties({
        family_id: globalFamilyId,
        brand_id: globalBrandId,
        country_id: globalCountryId,
        language_id: globalLanguageId,
        tag_id: globalTag,
        role_id: globalRoleId,
        type: 'novelties',
        requesttype: 0
      })
    )
  }, [globalFamilyId, globalBrandId, globalCountryId, globalLanguageId, globalTag, globalRoleId])

  if (loadingSkeleton) {
    return <>{componentSkeleton}</>
  }

  return (
    <>
      <Header title={t('updates')} />
      <SubHeader />
      <ContentFilter />

      <Container maxWidth="lg">
        <NoveltyPanel novelties={novelties} />
      </Container>
    </>
  )
}

export default NoveltyHome
